import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../hooks";
import { checkSubscriptionStatus, fetchSubscriptionUsageOverview, selectSubscriptionState } from "../slices/subscriptionSlice";
import { hasSubscriptionCheckTimedOut } from "../lib/checkSubscriptionTimeout";
import { toast } from "react-toastify";

export const useSubscriptionGuard = () => {
  const dispatch = useAppDispatch();
  const { 
    expired, 
    active, 
    hasSubscription, 
    loading, 
    lastCheckedAt, 
    usageOverview,
    permissions
  } = useAppSelector(selectSubscriptionState);

  const { employees, customers, products } = useAppSelector((state) => state);

  useEffect(() => {
    // console.log("Last checked at: ", lastCheckedAt);
    if(!lastCheckedAt || hasSubscriptionCheckTimedOut(lastCheckedAt as string)) {
      dispatch(checkSubscriptionStatus());
    }
  }, [lastCheckedAt]);

  useEffect(() => {
    if (!hasSubscription) {
    //   toast.warn("No subscription found")
    } else if (expired) {
        toast.warn("Subscription expired")
      // e.g. openModal("subscriptionExpired")
    }
  }, [hasSubscription, expired]);

  // Refetch usage overview when employees, customers, or products change
  useEffect(() => {
      dispatch(fetchSubscriptionUsageOverview());
  }, [employees.employees.length, customers.customers.length, products.products.length]);


  const isMaxEmployeeCountReached = () => {
    if(usageOverview) {
      return usageOverview.employeeCount >= permissions?.employeeLimit!;
    } else {
      console.log("Something went wrong checking employee limits")
      return false;
    }
    // return true
  };

  const isMaxStoreCountReached = () => {
    if(usageOverview) {
      return usageOverview.storeCount >= permissions?.storeLimit!;
    } else {
      console.log("Something went wrong checking store limits")
      return false;
    }
    // return true;
  };

  const isMaxProductCountReached = () => {
    if(usageOverview) {
      return usageOverview.productCount >= permissions?.itemLimit!;
    } else {
      console.log("Something went wrong checking product limits")
      return false;
    }
  };

  const isMaxSalesCountReached = () => {
    if(usageOverview) {
      return usageOverview.salesCount >= permissions?.monthlySalesLimit!;
    } else {
      console.log("Something went wrong checking monthly sales limits")
      return false;
    }
  };

  const isMaxCustomerCountReached = () => {
    if(usageOverview) {
      return usageOverview.customerCount >= permissions?.customerLimit!;
    } else {
      console.log("Something went wrong checking monthly sales limits")
      return false;
    }
  }

  return { 
    expired, 
    active, 
    hasSubscription, 
    loading, 
    usageOverview,
    permissions,
    isMaxEmployeeCountReached,
    isMaxStoreCountReached,
    isMaxSalesCountReached,
    isMaxProductCountReached,
    isMaxCustomerCountReached,
  };
};
